/* =====================================================
   TUNE store: product page, cart, collection and header cart count.
   Everything here is progressive: without JS the forms still post to Shopify.
   ===================================================== */
(function () {
  'use strict';

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* ---------- Header cart count ---------- */
  function setCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    $all('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count || 0);
        return cart;
      });
  }

  window.TUNE_refreshCartCount = refreshCartCount;

  /* ---------- Quantity steppers (product page + cart) ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) {
      return;
    }
    var wrap = btn.closest('[data-qty]');
    var input = wrap && $('input', wrap);
    if (!input) {
      return;
    }
    var min = parseInt(input.min, 10);
    if (isNaN(min)) {
      min = 0;
    }
    var value = parseInt(input.value, 10) || 0;
    value += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var variantsEl = $('[data-product-variants]', section);
    var variants = [];
    try {
      variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
    } catch (err) {
      variants = [];
    }

    var form = $('[data-product-form]', section);
    var idInput = $('[data-pdp-variant-id]', section);
    var select = $('[data-pdp-variant-select]', section);
    var priceNow = $('[data-pdp-price-now]', section);
    var priceWas = $('[data-pdp-price-was]', section);
    var status = $('[data-pdp-status]', section);
    var preorderNote = $('[data-pdp-preorder-note]', section);
    var addBtn = $('[data-pdp-add]', section);
    var waitlistBtn = $('[data-pdp-waitlist]', section);
    var dynamic = $('[data-pdp-dynamic]', section);
    var errorEl = $('[data-pdp-error]', section);
    var notice = $('[data-cart-notification]', section);
    var sticky = $('[data-pdp-sticky]', section);
    var stickyBtn = $('[data-pdp-sticky-btn]', section);
    var stickyPrice = $('[data-pdp-sticky-price]', section);
    var buyBlock = $('[data-pdp-buy]', section);

    var STOCK_BADGES = {
      in_stock: '<span class="stock-badge stock-badge--in">In stock</span>',
      preorder: '<span class="stock-badge stock-badge--pre">Pre-order</span>',
      sold_out: '<span class="stock-badge stock-badge--out">Sold out</span>'
    };

    function showMedia(mediaId) {
      if (!mediaId) {
        return;
      }
      var target = $('[data-media-id="' + mediaId + '"]', section);
      if (!target) {
        return;
      }
      $all('[data-media-id]', section).forEach(function (item) {
        var active = item === target;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
        if (!active) {
          $all('video', item).forEach(function (v) { v.pause(); });
        }
      });
      $all('[data-media-thumb]', section).forEach(function (thumb) {
        var active = thumb.getAttribute('data-media-thumb') === String(mediaId);
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    $all('[data-media-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-media-thumb'));
      });
    });

    function stickyLabel(variant) {
      if (!variant.available) {
        return 'Join waitlist';
      }
      return variant.stock === 'preorder' ? 'Pre-order' : 'Add to cart';
    }

    function applyVariant(variant) {
      if (!variant) {
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
      }
      if (priceNow) {
        priceNow.textContent = variant.price;
      }
      if (stickyPrice) {
        stickyPrice.textContent = variant.price;
      }
      if (priceWas) {
        priceWas.hidden = !variant.compare_at;
        priceWas.textContent = variant.compare_at || '';
      }
      if (status) {
        var badge = status.querySelector('.stock-badge');
        if (badge) {
          badge.outerHTML = STOCK_BADGES[variant.stock] || STOCK_BADGES.sold_out;
        }
      }
      if (preorderNote) {
        preorderNote.hidden = variant.stock !== 'preorder';
      }
      if (addBtn) {
        addBtn.hidden = !variant.available;
        addBtn.textContent = variant.stock === 'preorder' ? 'Pre-order now' : 'Add to cart';
      }
      if (waitlistBtn) {
        waitlistBtn.hidden = variant.available;
      }
      if (dynamic) {
        dynamic.hidden = !variant.available;
      }
      if (stickyBtn) {
        stickyBtn.textContent = stickyLabel(variant);
      }
      showMedia(variant.media_id);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (select) {
      select.addEventListener('change', function () {
        var id = Number(select.value);
        applyVariant(variants.filter(function (v) { return v.id === id; })[0]);
      });
    }

    function showError(message) {
      if (!errorEl) {
        return;
      }
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (event) {
        // Express checkout buttons submit through Shopify's own handler.
        if (event.submitter && event.submitter.name !== 'add') {
          return;
        }
        event.preventDefault();
        showError('');

        if (addBtn) {
          addBtn.disabled = true;
          addBtn.classList.add('is-loading');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                throw new Error(data.description || data.message || 'Could not add to cart.');
              }
              return data;
            });
          })
          .then(function () {
            if (notice) {
              notice.hidden = false;
              var focusTarget = notice.querySelector('a');
              if (focusTarget) {
                focusTarget.focus({ preventScroll: true });
              }
            }
            return refreshCartCount();
          })
          .catch(function (err) {
            showError(err.message);
          })
          .then(function () {
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.classList.remove('is-loading');
            }
          });
      });
    }

    // Sticky bar: appears on small screens once the real buttons are off screen.
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) {
            stickyBtn.tabIndex = show ? 0 : -1;
          }
        });
      });
      observer.observe(buyBlock);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var target = (addBtn && !addBtn.hidden) ? addBtn : waitlistBtn;
        if (target) {
          target.click();
        }
      });
    }
  }

  $all('[data-product-section]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  $all('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) {
      return;
    }
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () { /* recommendations are optional */ });
  });

  /* ---------- Cart page: quantities update on change ---------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var cartTimer = null;
    cartForm.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-qty]')) {
        return;
      }
      window.clearTimeout(cartTimer);
      cartTimer = window.setTimeout(function () {
        cartForm.classList.add('is-updating');
        var flag = document.createElement('input');
        flag.type = 'hidden';
        flag.name = 'update';
        flag.value = '1';
        cartForm.appendChild(flag);
        cartForm.submit();
      }, 450);
    });
  }

  /* ---------- Contact page: ?topic= preselects the topic, success gets focus ---------- */
  var topicSelect = $('[data-contact-topic]');
  if (topicSelect) {
    var wanted = (new URL(window.location.href).searchParams.get('topic') || '').toLowerCase();
    if (wanted) {
      Array.prototype.some.call(topicSelect.options, function (option) {
        if (option.value.toLowerCase().indexOf(wanted) !== -1) {
          topicSelect.value = option.value;
          return true;
        }
        return false;
      });
    }
  }
  var contactSuccess = $('[data-contact-page-success]');
  if (contactSuccess) {
    contactSuccess.focus();
  }

  /* ---------- Country / currency ----------
     Shopify only geolocates automatically on Plus, so on first visit we ask Shopify's
     browsing_context_suggestions endpoint (IP based) for the visitor's country and apply
     it once through the localization form. A manual pick always wins, and crawlers are
     left on the default so search results stay in the store's own currency. */
  var GEO_DONE = 'tuneGeoLocalized';
  var GEO_NOTICE = 'tuneGeoNotice';

  function storeGet(store, key) {
    try { return window[store].getItem(key); } catch (err) { return null; }
  }

  function storeSet(store, key, value) {
    try { window[store].setItem(key, value); } catch (err) { /* private mode */ }
  }

  function storeRemove(store, key) {
    try { window[store].removeItem(key); } catch (err) { /* private mode */ }
  }

  $all('[data-country-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      storeSet('localStorage', GEO_DONE, 'manual');
      select.form.submit();
    });
  });

  function looksLikeBot() {
    return navigator.webdriver ||
      /bot|crawl|spider|slurp|mediapartners|lighthouse|pagespeed|headless|preview/i.test(navigator.userAgent);
  }

  function showGeoNotice(countryName) {
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!currency) {
      return;
    }
    var notice = document.createElement('div');
    notice.className = 'geo-notice';
    notice.setAttribute('role', 'status');
    notice.innerHTML =
      '<span class="geo-notice_text"></span>' +
      '<button type="button" class="geo-notice_change">Change</button>' +
      '<button type="button" class="geo-notice_close" aria-label="Dismiss">×</button>';
    notice.querySelector('.geo-notice_text').textContent =
      'Prices shown in ' + currency + (countryName ? ' for ' + countryName : '') + '.';
    document.body.appendChild(notice);
    window.requestAnimationFrame(function () { notice.classList.add('is-visible'); });

    function close() {
      notice.classList.remove('is-visible');
      window.setTimeout(function () { notice.remove(); }, 250);
    }
    notice.querySelector('.geo-notice_close').addEventListener('click', close);
    notice.querySelector('.geo-notice_change').addEventListener('click', function () {
      close();
      var select = $('.site-footer [data-country-select]') || $('[data-country-select]');
      if (select) {
        select.scrollIntoView({ behavior: 'smooth', block: 'center' });
        select.focus({ preventScroll: true });
      }
    });
    window.setTimeout(close, 9000);
  }

  function localizeByIp() {
    var pending = storeGet('sessionStorage', GEO_NOTICE);
    if (pending) {
      storeRemove('sessionStorage', GEO_NOTICE);
      showGeoNotice(pending);
      return;
    }

    var form = $('[data-localization-form]');
    var current = window.Shopify && Shopify.country;
    if (!form || !current || storeGet('localStorage', GEO_DONE) || looksLikeBot()) {
      return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(current), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        storeSet('localStorage', GEO_DONE, 'auto');
        var suggestion = data && data.suggestions && data.suggestions[0];
        var country = suggestion && suggestion.parts && suggestion.parts.country;
        if (!country || !country.handle || country.handle === current) {
          return;
        }
        var select = form.querySelector('[name="country_code"]');
        if (!select || !select.querySelector('option[value="' + country.handle + '"]')) {
          return;
        }
        // Post the change in the background and reload once Shopify has stored it.
        // (A form.submit() fired this early in page life can be dropped by the browser.)
        var data = new FormData(form);
        data.set('country_code', country.handle);
        return fetch(form.getAttribute('action') || '/localization', {
          method: 'POST',
          body: data,
          credentials: 'same-origin'
        }).then(function () {
          storeSet('sessionStorage', GEO_NOTICE, country.name || '');
          window.location.reload();
        });
      })
      .catch(function () { /* stay on the default country */ });
  }

  if (document.readyState === 'complete') {
    localizeByIp();
  } else {
    window.addEventListener('load', localizeByIp);
  }

  /* ---------- Collection sorting ---------- */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
}());
